export enum shippingStatusEnum {
  PENDING = "PENDING",
  PACKING = "PACKING",
  SHIPPED = "SHIPPED",
  DELIVERED = "DELIVERED",
  REFUNDED = "REFUNDED",
  CANCELED = "CANCELED",
}
